import { CdkStepper } from '@angular/cdk/stepper';
import { Component } from '@angular/core';

@Component({
    selector: 'stepper',
    template: `
        <div>
            <ng-container [ngTemplateOutlet]="selected.content"> </ng-container>
        </div>
    `,
    styles: [``],
    providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
    standalone: false
})
export class StepperComponent extends CdkStepper {}
